import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-dark order-2 order-md-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold me-1" }, "2015-2024 © Gro Repository")
], -1)
const _hoisted_3 = { class: "menu menu-gray-600 menu-hover-primary fw-bold order-1" }
const _hoisted_4 = { class: "menu-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        'container-xxl': !_ctx.footerWidthFluid,
      }])
    }, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            href: "/article/52",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
              this.$router.push({
                name: 'article',
                params: { id: 52 },
              })
            ), ["prevent"])),
            class: "menu-link px-2"
          }, _toDisplayString(_ctx.$t("about")), 1)
        ])
      ])
    ], 2)
  ]))
}